import { Component, NgModule } from '@angular/core';
import { UserService } from '@service/user/user.service';

import { MatDialog } from '@angular/material/dialog';
import { ScrollService } from '@service/scroll.service';
import { environment } from '@environments/environment';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { SliderComponentModule } from '@component/slider/slider.component';
import { FullWidthImageComponent } from '@component/full-width-image/full-width-image.component';
import { BenefitsComponent } from '@component/benefits/benefits.component';
import { SharedModule } from 'src/app/shared.module';
import { StateService } from '@service/state.service';
import { DialogService } from '@service/dialog.service';
import { ImageSliderComponentModule } from '@component/generic/image-slider/image-slider.component';
import { NewsfeedBannerModule } from 'src/app/newsfeed-banner.module';

@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.scss'],
})
export class FrontPageComponent {
  public environment = environment;

  public b1 = [
    {
      id: 1,
      content: 'Hilfe bei Unsicherheiten, Zimmerer helfen Zimmerer.',
    },
    {
      id: 2,
      content: 'Zimmerer- und Holzbauthemen: Du bleibst informiert.',
    },
    {
      id: 3,
      content: 'Kaufen und verkaufen am Marktplatz.',
    },
    {
      id: 4,
      content: 'Mitarbeiter und Jobs finden.',
    },
    {
      id: 5,
      content: 'Zünftig: Erfolg, Spaß und Gemeinsamkeit.',
    },
    {
      id: 6,
      content: 'Und alles für Zimmerer kostenlos.',
    },
  ];

  public statements = [
    {
      text: '„Nie hätten wir gedacht, dass der Verkauf vom LKW so schnell über die Bühne gehen würde. Dank Zimmerer-Treffpunkt haben wir ihn verkaufen können. Die Reichweite hat es ermöglicht, dass der LKW ab kommenden Jahr seinen Dienst in Nordhessen weiter verrichten wird. Gerne nutzen wir wieder Eure Seite zum Verkauf von Zimmerei Maschinen!!!“',
      img: environment.publicFolder + 'assets/images/frontpageStatements/max_sturm.jpg',
      name: 'Max Sturm',
    },
    {
      text: '„Bei der Suche nach einer neuen Stelle als Zimmerer habe ich ein Stellengesuch in die Jobbörse eingestellt. Ich habe bereits am Tag nach der Anzeigenveröffentlichung mehrere Anfragen erhalten und bin mit der Abwicklung sehr zufrieden. Mit einer Zimmerei habe ich schon ein Gespräch vereinbart.“',
      img: environment.publicFolder + 'assets/images/frontpageStatements/florian_donhauser.jpg',
      name: 'Florian Donhauser',
    },
    {
      text: '„Wir haben im Marktplatz unseren Montagetisch verkauft. Das Inserieren war einfach, schnell und unkompliziert, genau wie die Abwicklung des Verkaufs. Es haben sich einige Interessenten gemeldet und wir konnten den Montagetisch schnell verkaufen. Jetzt sind wir eine positive Erfahrung reicher und empfehlen den Marktplatz ganz klar weiter!“',
      img: environment.publicFolder + 'assets/images/frontpageStatements/reich.jpg',
      name: 'Zimmerei Reich, Aindling',
    },
  ];

  public faq = [
    {
      question: 'Dauert die Registrierung wirklich nur 2 Minuten?',
      answer:
        'Ja, denn bei uns werden bei der Registrierung nur die notwendigsten Daten abgefragt. Danach bekommt man nur noch eine E-Mail in sein Postfach, welche man bestätigen muss. Mehr Aufwand ist es nicht.',
    },
    {
      question: 'Was nützt mir eine Registrierung beim Zimmerer-Treffpunkt?',
      answer:
        'Als Zimmerer oder Zimmerin kannst Du kostenlos Mitglied einer großen und guten Gemeinschaft werden. Unsere Mitglieder sind Zimmerer aus dem ganzen deutschsprachigen Raum: Azubis, Gesellen, Meister, Arbeitnehmer genauso wie Arbeitgeber. Wenn Du dich in dieser Gemeinschaft austauschen und informieren willst, bist Du dazu herzlich eingeladen.',
    },
    {
      question: 'Wie einfach ist es hier Beiträge zu erstellen?',
      answer:
        'Sehr einfach! Einfach auf Beitrag/Anzeige erstellen klicken und schon wird man durch eine kurze einfache Schrittfolge geführt. Zuerst Titel und Text eingeben, dann Bild hochladen und schon ist man fertig. Innerhalb kürzester Zeit kannst Du selbstständig so einen Beitrag bzw. eine Anzeige online schalten. Das funktioniert am PC, Tablet und am Smartphone.',
    },
    {
      question: 'Wie viele Daten muss ich bei der Registrierung eingeben?',
      answer: 'Bei der Registrierung müssen nur Vorname, Nachname, E-Mail-Adresse und ein Passwort eingegeben werden.',
    },
    {
      question: 'Ist der Zimmerer-Treffpunkt wirklich kostenlos?',
      answer:
        'Ja! Für Zimmerer und Zimmerinnen ist der Zimmerer-Treffpunkt immer kostenlos. Du kannst bei uns also Stellenanzeigen, Stellengesuche, Marktplatz-Inserate und eigene News kostenlos veröffentlichen. Das ist deshalb möglich, weil wir ein kleines motiviertes Team sind und diese Plattform über Kooperationen mit Herstellern finanzieren. Hersteller und Lieferanten der Branche veröffentlichen bei uns also kostenpflichtige Fachbeiträge, welche Zimmerern wiederum einen Mehrwert an fachlicher Information bieten.',
    },
  ];

  public b3 = [
    // profile
    {
      text: '<b>Profil</b> - Mit Deinem persönlichen Profil kannst Du Dich mit anderen vernetzen, fragen und diskutieren.',
      icon: '<i class="fas fa-user"></i>',
      action: () => {
        if (this.userService.isLoggedIn) {
          this.StateService.goto('/profile/about');
        } else {
          this.DialogService.loginRegistrationDialog();
        }
      },
    },

    // blog
    {
      text: '<b>Blog</b> - Im Blog erfährst Du Neues aus der Branche und kannst selbst Blog-Beiträge erstellen.',
      icon: '<i class="far fa-newspaper"></i>',
      state: '/blog',
    },

    // wiki
    {
      text: '<b>Wiki</b> - Im Wiki bekommst Du Fachwissen, gebündelt und auf den Zimmerer zugeschnitten. Bibliothek, Nachschlagewerk und Bildungsprogramm.',
      icon: '<i class="fas fa-university"></i>',
      // state: 'frontend.app.wiki.list',
      state: '/grundwissen',
    },

    // marketplace
    {
      text: '<b>Marktplatz</b> - Verkaufe Gebrauchtes oder Neues im Marktplatz. Erstelle kostenlos Kleinanzeigen. Hier sehen es mehr Zimmerer als überall anders.',
      icon: '<i class="fas fa-shopping-cart"></i>',
      state: '/market',
    },

    // jobs
    {
      text: '<b>Jobbörse</b> - Erstelle als Arbeitgeber Stellenanzeigen oder als Arbeitnehmer Stellengesuche. Zeige Dich mit einem Unternehmensprofil von der besten Seite.',
      icon: '<i class="fas fa-handshake"></i>',
      state: '/job',
    },

    // forum
    {
      text: '<b>Forum</b> - Im Forum kannst Du dich austauschen und netzwerken. Hast Du eine Frage, besondere Baustellen oder eine Unsicherheit? Poste es, Deine Kollegen helfen Dir weiter.',
      icon: '<i class="fas fa-comments"></i>',
      action: () => {
        window.open('https://www.facebook.com/groups/725765151265175', '_blank');
      },
    },
  ];

  constructor(
    public userService: UserService,
    private matDialog: MatDialog,
    private ScrollService: ScrollService,
    public StateService: StateService,
    public DialogService: DialogService,
  ) {}

  public usageClick(item) {
    if (typeof item.action != 'undefined' && item.action) {
      item.action();
    } else if (typeof item.state != 'undefined' && item.state) {
      this.StateService.goto(item.state, {}, true, false);
    }
  }

  public openLoginRegistration(dialog: string) {
    this.DialogService.loginRegistrationDialog(dialog);
  }
}

@NgModule({
  declarations: [FrontPageComponent, FullWidthImageComponent, BenefitsComponent],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        component: FrontPageComponent,
      },
    ]),

    SliderComponentModule,

    MatExpansionModule,
    ImageSliderComponentModule,
    NewsfeedBannerModule,
  ],
  exports: [
    FrontPageComponent,
    FullWidthImageComponent,
    BenefitsComponent,

    SharedModule,
    SliderComponentModule,

    MatExpansionModule,
  ],
})
export class FrontPageComponentModule {}
